export default "__VITE_ASSET__ac04b2ab__"